import { Tooltip, InputAdornment } from "@mui/material";

// ICON
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// COPY COMMAND
export default function CopyCommand({ commandString }: CopyCommandProps) {
    return (
        <Tooltip title="Copy" placement="top" arrow>
            <InputAdornment position="start" onClick={() => navigator.clipboard.writeText(commandString)}>
                <ContentCopyIcon
                    sx={{
                        '&:hover': {
                            color: 'var(--teal)'
                        },
                        fontSize: 18,
                        transition: '.2s',
                        cursor: 'pointer'
                    }}
                />
            </InputAdornment>
        </Tooltip>
    )
}
